<script setup>
import { computed, ref, useAttrs, useListeners } from 'vue'

defineProps({
    type: {
        type: String,
        default: 'text',
    },
    value: {
        type: [String, Number],
        default: '',
    },
})

const emit = defineEmits(['input'])

const attrs = useAttrs()
const boundListeners = useListeners()

const showPassword = ref(false)

const listeners = computed(() => ({
    ...boundListeners,
    input: event => emit('input', event.target.value),
}))

function togglePasswordVisibility() {
    showPassword.value = !showPassword.value
}
</script>

<template>
    <div class="base-input">
        <input
            :type="showPassword ? 'text' : type"
            :value="value"
            class="input"
            v-bind="attrs"
            v-on="listeners"
        >
        <div
            v-if="type === 'password'"
            class="password-toggle"
            @click="togglePasswordVisibility"
        >
            <BaseIcon
                class="eye-icon"
                :name="showPassword ? 'eye-open' : 'eye-closed'"
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.input {
    @extend %input;
}

.base-input {
    position: relative;

    &.error .input {
        background-color: transparentize($c-red, 0.95);
    }
}

.password-toggle {
    position: absolute;
    top: 0;
    right: $s-m;
    display: flex;
    align-items: center;
    height: $size-input-height;
    cursor: pointer;
}

.eye-icon {
    max-width: 22px;
    max-height: 22px;
    opacity: 0.5;
    fill: $c-text-faded;
}
</style>
